import React, { useState } from "react";
import axios from "axios";
import trainingsApi from 'utils/trainingsApi';
import { navigate } from 'gatsby';
import { Modal } from 'antd';
import {
    useElements,
    useStripe,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from '@stripe/react-stripe-js';

const ErrorMessage = ({ children }) => (
    <ul className="card-errors">
        <li>{children}</li>
    </ul>
);

const CARD_OPTIONS = {
    style: {
        base: {
            '::placeholder': {
                color: '#fff',
            },
        }

    },
};


const StripeBtn = (props) => {
    const stripe = useStripe();
    const elements = useElements();
    const training = props.training
    const discount = props.discount
    const [error, setError] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [isBtnClicked, setBtnClicked] = useState(false)


    function removeSearchParams(trainingId) {
        const index = trainingId.indexOf('&');
        return index === -1 ? trainingId : trainingId.substring(0, index);
    }

    const onToken = token => {
        const body = {
            selectCountry:props.country,
            amount: props.amount,
            token: token
        };
         axios.post(trainingsApi.stripePayment, body)
            .then(response => {
                console.log(response);
                const trainees = props.input.map((i) => ({
                    fullName: `${i.firstname} ${i.lastname}`,
                    email: i.email.trim(),
                    phone: i.phone.trim(),
                    title: i.jobtitle.trim(),
                    company: i.company.trim(),
                }));

                props.setLoadingFunc(true);
                axios.post(trainingsApi.enroll, {
                    orderId: response.data.id,
                    trainees,
                    trainingId: removeSearchParams(
                        props.trainingId,
                    ),
                    couponId: discount
                        ? Number(discount.couponId)
                        : 0,
                    isStripePayment: true,
                    stripePaymentDetails: response.data
                })
                    .then(({ data }) => {
                        props.setLoadingFunc(false);
                        if (data.operation === 'Success')
                            navigate('/thanks/');
                    })
                    .catch((error) => {
                        props.setLoadingFunc(false);
                    });

            })
            .catch(error => {
                console.log("Payment Error: ", error);
                const trainees = props.input.map((i) => ({
                    fullName: `${i.firstname} ${i.lastname}`,
                    email: i.email.trim(),
                    phone: i.phone.trim(),
                    title: i.jobtitle.trim(),
                    company: i.company.trim(),
                }));
                const paymentMethod = 'Stripe'
                axios.post(trainingsApi.paymentError, {
                    trainees,
                    training,
                    paymentMethod
                });
            });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }
        setBtnClicked(true)
        const payload = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardNumberElement),
        });


        if (payload.error) {
            setError(payload.error);
            setBtnClicked(false)
        } else {
            const card = elements.getElement(CardNumberElement);
            const result = await stripe.createToken(card)
            setPaymentMethod(payload.paymentMethod);
            onToken(result.token);
            props.setLoadingFunc(true);
            props.handleCancelFunc()
        }
    };

    return (
        <div>
            <Modal
                style={{ top: 50 }}
                visible={props.visible}
                footer={null}
                onCancel={props.handleCancelFunc}
            >
                <div><h3 className="popup-head">Enter Card Details</h3></div>
                <form className="Form" onSubmit={handleSubmit}>
           

                    <div className="stripe-form-group stripe-checkout">
                        <label className="stripe-checkout-label">Card Number</label>
                        <CardNumberElement
                            options={CARD_OPTIONS}
                            className="stripe-checkout-input"
                            onChange={(e) => {
                                setError(e.error);
                            }} />
                    </div>

                    <div className="stripe-form-group stripe-checkout">
                        <label className="stripe-checkout-label">Expiration</label>
                        <CardExpiryElement className="stripe-checkout-input"
                            onChange={(e) => {
                                setError(e.error);
                            }}
                        />
                    </div>
                    <div className="stripe-form-group stripe-checkout">
                        <label className="stripe-checkout-label">CVC</label>
                        <CardCvcElement className="stripe-checkout-input"
                            onChange={(e) => {
                                setError(e.error);
                            }} />
                    </div>

                    {error && <ErrorMessage>{error.message}</ErrorMessage>}
                    <div className="stripe-checkout-btn-area">
                        <button
                            className="stripe-checkout-btn"
                            disabled={isBtnClicked}
                            type="submit">
                            <i className="fas fa-lock" />
                            <span>{props.btnData}</span>
                        </button>
                    </div>
                </form>
            </Modal>
        </div >
    );
};
export default StripeBtn;